<template>
    <div class="page">
        <div class="title">长按下方二维码注册激活设备</div>
        <img src="@/assets/img/bg.png" class="code-img"/>
        <div>
            设备号：{{value}}
            <span :data-clipboard-text="value" class="copy-btn right copy_id" @click="copy()">复制</span>
        </div>
    </div>
</template>
<script>
import Clipboard from 'clipboard';
export default{
    data(){
        return{
            value:'24213213213123'
        }
    },
    methods:{
        copy(){
            var clipboard = new Clipboard('.copy_id')
            clipboard.on('success', e => {
              Toast.fail('复制成功');
                // 释放内存
                clipboard.destroy()
            })
            clipboard.on('error', e => {
                // 不支持复制
                Toast.fail('该浏览器不支持自动复制')
                // 释放内存
                clipboard.destroy()
            })
        }
    }
}
</script>
<style scoped lang="less">
.page{
    height:100%;
    text-align: center;
    .title{
        font-size:16px;
        text-align: center;
        padding-top:140px;
    }
    .code-img{
        width:200px;
        height:200px;
        margin:20px 0;
    }
    .copy-btn{
        color: cadetblue;
    }
}
</style>